var _mask, _path, _mask2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolScroll(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 566,
    viewBox: "0 0 6 566",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_909_2461",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 48L6 170H2L2 48H6Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 48L3 170H9L9 48H3Z",
    fill: "black",
    mask: "url(#path-1-inside-1_909_2461)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_909_2461",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 0L3 566H0L0 0L3 0Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 0L2 566H4L4 0L2 0Z",
    fill: "#C8C8C8",
    mask: "url(#path-3-inside-2_909_2461)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolScroll);
export default __webpack_public_path__ + "static/media/solScroll.649257e3a7158dd3345b28982e81bb94.svg";
export { ForwardRef as ReactComponent };